var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrn5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 349,
    viewBox: "0 0 279 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.849 242.164C301.99 154.018 260.625 51.7671 172.164 14.4929C84.0189 -22.6481 -18.2324 18.7167 -55.5066 107.178C-92.7808 195.639 -51.2828 297.574 37.1782 334.848C125.456 371.674 227.708 330.309 264.849 242.164ZM229.78 227.387C200.627 296.576 120.828 328.801 51.9548 299.78C-17.2344 270.626 -49.4587 190.828 -20.4381 121.954C8.71566 52.7651 88.5143 20.5408 157.388 49.5614C226.71 78.3993 258.934 158.198 229.78 227.387Z",
    fill: "url(#paint0_linear_80_38)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_38",
    x1: -104.779,
    y1: 224.114,
    x2: 224.391,
    y2: 338.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#129106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EBF4E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrn5);
export default __webpack_public_path__ + "static/media/orn5.bad744e2cc585f433a6bec28faa3f816.svg";
export { ForwardRef as ReactComponent };